export default {
  actionTypes: {
    loadPoDetails: 'LOAD_PODETAILS',
    onCurrentLineItemChanged: 'ON_CURRENT_LINE_ITEM_CHANGED',
    isPoExists: 'PURCHASE_ORDER_IS_EXISTS',
    loadOrderToList: 'LOAD_ORDER_TO_LIST',
    loadLineItemUploadedImages: 'PO_LOAD_LINE_ITEM_UPLOADED_IMAGES',
    loadLineItemApprovedImages: 'PO_LOAD_LINE_ITEM_APPROVED_IMAGES',
    loadLineItemActivitiy: 'PO_LOAD_LINE_ITEM_ACTIVITY',
    checkCanAddComment: 'PO_CHECK_CAN_ADD_COMMENT',
    resetLineItemInfo: 'PO_CLEAN_LINE_ITEM_INFO',
    uploadImages: 'PO_UPLOAD_IMAGES',
    uploadImagesMultiple: 'PO_UPLOAD_IMAGES_MULTIPLE',
    updateLineItemsStatus: 'PO_UPDATE_LINE_ITEMS_STATUS',
    syncLineItemsStatus: 'PO_SYNC_LINE_ITEMS_STATUS',
    getApprovalDocument: 'PO_GET_APPROVAL_DOCUMENT',
    reportIssue: 'PO_REPORT_ISSUE',
    deleteImage: 'PO_DELETE_IMAGE',
    deleteImageMultiple: 'PO_DELETE_IMAGE_MULTIPLE',
    processLineItems: 'PO_PROCESS_LINE_ITEMS',
    itemCommented: 'PO_COMMENT_LINE_ITEMS',
    deleteCommentMultiple: 'PO_DELETE_COMENT_MULTIPLE',
    clearResults: 'CLEAR_RESULTS',
  },
  mutationTypes: {
    setPoNumber: 'SET_PO_NUMBER',
    setClients: 'SET_PO_CLIENTS',
    setPoLineItems: 'SET_PO_LINE_ITEMS',
    setPoGroupedLineItems: 'SET_PO_GROUPED_LINE_ITEMS',
    setCurrentLineItemId: 'SET_CURRENT_LINE_ITEM_ID',
    setCurrentGroupLineItemNumber: 'SET_CURRENT_LINE_ITEM_NUMBER',
    setCurrentLineItemUploadedImages: 'SET_CURRENT_LINE_ITEM_UPLOADED_IMAGES',
    setCurrentLineItemApprovedImages: 'SET_CURRENT_LINE_ITEM_APPROVED_IMAGES',
    setCurrentLineItemActivity: 'SET_CURRENT_LINE_ITEM_ACTIVITY',
    setLoading: 'SET_PO_LOADING',
    setImagesUploading: 'SET_IMAGES_UPLOADING',
    setUploadedImagesLoading: 'SET_CURRENT_LINE_ITEM_UPLOADED_IMAGES_LOADING',
    setApprovedImagesLoading: 'SET_CURRENT_LINE_ITEM_APPROVED_IMAGES_LOADING',
    setActivityLoading: 'SET_CURRENT_LINE_ITEM_ACTIVITY_LOADING',
    setActionsDisabled: 'SET_ACTIONS_DISABLED',
    setCurrentLineItemActivityCanAddComment: 'SET_CURRENT_LINE_ITEM_ACTIVITY_CAN_ADD_COMMENT',
    setCurrentLineItemActivityIsAssignedToClient: 'SET_CURRENT_LINE_ITEM_ACTIVITY_IS_ASSIGNET_TO_CLIENT',
    searchFinished: 'SEARCH_FINISHED',
    clearResults: 'CLEAR_RESULTS',
    toggleSku: 'TOGGLE_SKU',
    changeNumberOfBoxes: 'CHANGE_NUMBER_OF_BOXES',
    changeBox: 'CHANG_EBOX',
  },
  getterTypes: {
    currentLineItemInfo: 'currentLineItemInfo',
    currentLineItemImagesCount: 'currentLineItemImagesCount',
    currentLineItemStatus: 'currentLineItemStatus',
    currentLineInfoLoading: 'currentLineInfoLoading',
  },
};
